import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneZero = ({
  // Main heading text
  titleText,
  titleFont,
  titleFontSize,
  titleColor,
  titleTextAlign,
  titleIsBold,
  titleIsItalic,
  titleIsUnderline,
  titleUppercase = false,
  titleLetterSpacing,
  // Subtitle text
  subtitleText,
  subtitleFont,
  subtitleColor = "#FFFFFF",
  subtitleFontSize,
  subtitleTextAlign,
  subtitleIsBold,
  subtitleIsItalic,
  subtitleIsUnderline,

  // Button defaults
  buttonLabel,
  buttonFont = "Poppins",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize,
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#599E10",

  // Background
  backgroundColor,
  backgroundImage,
  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  center = false,
  onClose,
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
      } w-full flex flex-col mx-auto items-center justify-between px-4 md:px-8 py-4 md:py-3 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex flex-col items-center justify-between w-full max-w-4xl mx-auto gap-4 md:gap-6 h-full">
        {/* Main Heading */}
        <div
          className={`font-bebas leading-tight text-center mt-5 ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            textAlign: titleTextAlign || "center",
            fontFamily: titleFont || "Bebas Neue",
            textTransform: titleUppercase ? "uppercase" : "none",
            ...(titleLetterSpacing
              ? { letterSpacing: titleLetterSpacing }
              : {}),
          }}
        >
          {titleText}
        </div>

        {/* Subtitle */}
        {subtitleText && (
          <div
            className={`font-poppins leading-relaxed text-center ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              fontSize: `${subtitleFontSize}px`,
              color: subtitleColor,
              textAlign: subtitleTextAlign || "center",
              fontFamily: subtitleFont || "Poppins",
              whiteSpace: "pre-line",
            }}
          >
            {subtitleText}
          </div>
        )}

        {/* Button */}
        <div className="flex-shrink-0">
          <button
            className={`px-4 py-3 md:px-6 md:py-3 rounded-full font-poppins transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap ${
              explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
            } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont || "Poppins",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneZero;
